import * as React from "react"
import { Skeleton, Grid, Box } from "@mui/material"
import { CardSeeker, ImageSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils";

import { useSkuDetailsProductDetailsData } from "./@hooks"
import ProductDetailsBlock from "./DetailsBlock";

export default function SkuDetailsProductDetails() {

    const { productDetailsData, isLoadingProductDetails, skuID } = useSkuDetailsProductDetailsData()

    if (isLoadingProductDetails) return <Skeleton height={300} />
    if (isEmpty(productDetailsData)) return <></>

    return <CardSeeker sx={{ height: '100%'}}>
        <Grid container spacing={2}>

            <Grid item xs={6}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <ImageSeeker
                        src={`/api/master-data/sku/image/${skuID}`}
                        sx={{ width: 1, height: "auto", maxHeight: 400 }} 
                    />
                </Box>
            </Grid>

            <Grid item xs={6} >
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <ProductDetailsBlock
                        sku={productDetailsData.skuName}
                        category={productDetailsData.category}
                        brand={productDetailsData.brand}
                        ean={productDetailsData.ean}
                        firstSeen={productDetailsData.firstSeen}
                        lastSeen={productDetailsData.lastSeen}
                    />
                </Box>
            </Grid>

        </Grid>
    </CardSeeker>
}